import { useRef, useEffect } from "react";
import { createRoot } from "react-dom/client";

import "./admin.scss";
import htmlToElement from "./../../wp-utils/v1/htmlToElement";

export const googleDrivePicker = ({ container, field, appId, clientId, developerKey }) => {
  if (!container || !appId || !clientId || !developerKey) {
    return false;
  }

  const button = document.createElement("button");
  button.classList.add("drive-picker-button");
  button.innerText = "Choose From Google Drive";
  container.appendChild(button);

  button.addEventListener("click", function (e) {
    e.preventDefault();
    loadPicker();
  });

  var scope = ["https://www.googleapis.com/auth/drive.file"];

  var pickerApiLoaded = false;
  var oauthToken;
  function loadPicker() {
    gapi.load("auth", { callback: onAuthApiLoad });
    gapi.load("picker", { callback: onPickerApiLoad });
  }
  function onAuthApiLoad() {
    window.gapi.auth.authorize(
      {
        client_id: clientId,
        scope: scope,
        immediate: false,
      },
      handleAuthResult
    );
  }
  function onPickerApiLoad() {
    pickerApiLoaded = true;
    createPicker();
  }
  function handleAuthResult(authResult) {
    if (authResult && !authResult.error) {
      oauthToken = authResult.access_token;
      createPicker();
    }
  }
  // Create and render a Picker object for searching images.
  function createPicker() {
    if (pickerApiLoaded && oauthToken) {
      var view = new google.picker.View(google.picker.ViewId.DOCS);
      // view.setMimeTypes("image/png,image/jpeg,image/jpg");
      var picker = new google.picker.PickerBuilder()
        .setAppId(appId)
        .setOAuthToken(oauthToken)
        .addView(view)
        .addView(new google.picker.DocsUploadView())
        .setDeveloperKey(developerKey)
        .setCallback(pickerCallback)
        .build();
      picker.setVisible(true);
    }
  }

  // A simple callback implementation.
  function pickerCallback(data) {
    if (data.action == google.picker.Action.PICKED) {
      if (!data.docs?.[0]?.embedUrl) {
        createPicker();
      } else {
        if (field) field.value = data.docs[0]?.embedUrl;
        return data.docs[0]?.embedUrl;
      }
    }
  }
};
window.googleDrivePicker = googleDrivePicker;

(function ($) {
  $(document).ready(function () {
    //import data
    $(document).on("click", ".fpdf_import_data", function (e) {
      e.preventDefault();
      $.ajax({
        url: fpdfAdmin.ajaxUrl,
        data: {
          action: "fpdf_import_data",
        },
        success: function (data) {
          const result = JSON.parse(data);
          if (result.success === true) {
            location.href = location.href + "?pdfp-import=success";
          }
        },
      });
    });

    // set cookie
    $(".fpdf_import_notice").on("click", function () {
      setCookie("fpdf_import_notice", "1", 17280000);
    });

    // set cookie function
    function setCookie(cookieName, cookieValue, expiryInSeconds) {
      var expiry = new Date();
      expiry.setTime(expiry.getTime() + 1000 * expiryInSeconds);
      document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expiry.toGMTString() + ";path=/";
    }

    // copy shortcode

    $(document).on("click", ".pdfp_front_shortcode input", function (e) {
      e.preventDefault();

      let shortcode = $(this).parent().find("input")[0];
      shortcode.select();
      shortcode.setSelectionRange(0, 30);
      document.execCommand("copy");
      $(this).parent().find(".htooltip").text("Copied Successfully!");
    });
  });
  $(".pdfp_front_shortcode input").on("mouseout", function () {
    $(this).parent().find(".htooltip").text("Copy To Clipboard");
  });
  // $(".pdfp_front_shortcode input").on("click", function (e) {});
})(jQuery);
